
import {initWebComponent} from "@/helpers/web-component-helper";
import sw from "datatables.net-plugins/i18n/sw.mjs";
import {showEmbedModal} from "@/components/layout/embed-model-component.js";

export class LayerInfoInfoTypeUrlComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const childKey = this.getAttribute('data-child-key')
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')
        const recordIndex = this.getAttribute('data-record-index')

        let attributeItem
        if(recordIndex === null) {
            attributeItem = window.attributeItems[featureKey][featureInfoKey].attributeItems[key]
        } else {
            if(childKey) {

                attributeItem = window.attributeItems[featureKey][featureInfoKey].records[recordIndex].attributeItems[key][childKey]
            } else {

                attributeItem = window.attributeItems[featureKey][featureInfoKey].records[recordIndex].attributeItems[key]
            }
        }

        const template = document.createElement('template');
        const url = attributeItem.Prefix + attributeItem.Value + attributeItem.Suffix

        if(url === '') {
            template.innerHTML = ''
        } else {
            switch (attributeItem.Action) {
                case 2:
                    template.innerHTML = `<div class="embed-responsive embed-responsive-4by3 h-100">
                                            <iframe
                                                class="embed-responsive-item"
                                                seamless=""
                                                allowTransparency="true"
                                                allowFullScreen=""
                                                src="` + url + `">
                                            </iframe>
                                        </div>`
                    break;
                case 3:
                    showEmbedModal(url)
                    template.innerHTML = `<a target="_blank" href="${url}">Open link</a>`;
                    break;
                default:
                    template.innerHTML = `<a target="_blank" href="${url}">Open link</a>`;
                    break;
            }
        }

        initWebComponent(this, template)
    }
}

